<template>
  <div class="py-6">
    <div
      class="grid gap-4 md:gap-8 lg:gap-16"
      :class="{
        'md:grid-cols-2': columns == 2,
        'lg:grid-cols-3': columns == 3,
        'lg:grid-cols-4': columns == 4,
      }"
    >
      <div
        v-for="(video, index) in videoData"
        :key="video.url"
        class="w-full aspect-video bg-cover bg-center cursor-pointer group border-8 hover:border-accent flex items-center justify-center rounded-2xl"
        v-lazy:background="video.photo ? video.photo.sizes.medium : getYtImage(video.youtube_code)"
        @click="openVideo(index)"
      >
        <div class="w-24 lg:w-32 aspect-square flex justify-center items-center bg-accent/80 group-hover:bg-accent transition-all duration-300 cursor-pointer py-2.5 px-5 rounded-full tracking-wider text-white pl-6">
          <svg-vue icon="play" class="fill-current inline-block w-1/2 aspect-square"></svg-vue>
        </div>
      </div>
    </div>
    <teleport to="#popup-target">
      <div v-if="popupOpen" class="fixed z-50 top-0 h-screen w-full bg-primary-dark bg-opacity-80 flex flex-col justify-center" >
        <div class="w-full h-full flex flex-col">

          <span @click="popupOpen = false" class="absolute text-white flex items-center leading-none h-10 px-6 bg-blue border-4 border-white shadow-xl right-4 top-4 lg:right-8 cursor-pointer uppercase text-sm" >
            <svg-vue icon="times" class="fill-current h-4 w-4 mr-2"></svg-vue>
            close
          </span>

          <div class="flex-grow lg:h-full w-full flex py-20 lg:p-20">
            <iframe :title="videoData[activeIndex].title" class="w-full aspect-video shadow-xl mx-auto"
              :src="'https://www.youtube-nocookie.com/embed/' + videoData[activeIndex].youtube_code + '?autoplay=1&rel=0&showinfo=0'"
              allow="autoplay; encrypted-media" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
          </div>

          <div class="relative w-full max-w-xs mx-auto bg-white shadow-xl flex justify-between mt-4 lg:-mt-16 p-1 z-20 mb-16" >
            <span @click="prevVideo" class="leading-none h-10 px-6 bg-primary text-white flex items-center cursor-pointer uppercase text-sm" >
              <svg-vue icon="angle-right" class="rotate-180 fill-current h-4 w-4 mr-2"></svg-vue>
              <span class="sr-only">prev</span>
            </span>
            <span class="text-blue font-bold flex items-center leading-none"> {{ activeIndex + 1 }} of {{ videoData.length }}</span>
            <span @click="nextVideo" class="leading-none h-10 px-6 bg-primary text-white flex items-center cursor-pointer uppercase text-sm" >
              <span class="sr-only">next</span>
              <svg-vue icon="angle-right" class=" fill-current h-4 w-4 ml-2"></svg-vue>
            </span>
          </div>

        </div>

      </div>
    </teleport>
  </div>
</template>

<script>
export default {
  name: "VideoFeed",

  props: {
    videos: {
      type: Object,
      default: () => {}
    },
    columns: {
      type: Number,
      default: 1
    }
  },

  data () {
    return {
      activeVideo: {},
      videoData: [],
      popupOpen: false,
      activeIndex: 0
    }
  },

  mounted () {
    this.videoData = this.videos
  },

  methods: {
    openVideo (num) {
      this.popupOpen = true
      this.activeIndex = num
      this.activeVideo = this.videoData[num]
    },

    nextVideo () {
      if((this.activeIndex+1) == this.videoData.length){
        this.activeIndex = 0
      } else {
        this.activeIndex++
      }

      this.openVideo(this.activeIndex)
    },

    prevVideo () {
      if((this.activeIndex+1) == 1){
        this.activeIndex = this.videoData.length
      } else {
        this.activeIndex--
      }

      this.openVideo(this.activeIndex)
    },

    checkIfImageExists(url, callback) {
      const img = new Image();
      img.loading = 'lazy'
      img.src = url;

      console.log(img)

      if (img.complete) {
        callback(true);
        console.log(url + ' complete!')

      } else {
        img.onload = () => {
          callback(true);
          console.log(url + ' found!')
        }

        img.onerror = () => {
          callback(false);
          console.log(url + ' not found')
        }
      }

      callback(false)
    },

    imageExists(image_url) {
      var http = new XMLHttpRequest();
      http.open('HEAD', image_url, false);

      if(http.send() && http.status != 404){
        return true
      }

      return false
    },

    async checkImage(imageSrc) {
      const response = await fetch(imageSrc, { mode: 'no-cors' })
      console.log(response)

      if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
      }

      return response
    },

    getYtImage(code) {
      return 'https://img.youtube.com/vi_webp/' + code + '/1.webp'
    }

  }
}
</script>

